import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})

/**
 * @Description this service contains all the logic concerning to remote logs.
 * @date 2020-11-03
 * @param {any} privatelogger:NGXLogger the library we use to remote log.
 * @returns void
 */
export class LogService {
 /**
  * @ignore
  * @params logger
  */
  constructor(private logger: NGXLogger) {
    this.logger = logger;
  }
  /**
   * @Description this method is used to trace any error (http and user errors)
   * @date 2020-11-03
   * @param  error -->this is the string/object containing the error
   */
  traceError(error: any): void {
    this.logger.error(error);
  }
  /**
   * @Description this is the method to trace any warn
   * @date 2020-11-03
   * @param  warn -->the string/object containing the warn
   */
  traceWarn(warn: any): void {
    this.logger.warn(warn);
  }
  /**
   * @Description this method is used to trace any info
   * @date 2020-11-03
   * @param  info any info you want to log
   */
  traceInfo(info: any): void {
    this.logger.info(info);
  }
}
